export default __webpack_public_path__ + "static/media/NeerajSir.cdbb9bb6.webp";